import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PropTypes from "prop-types";
import * as moment from "moment";
import * as Modal from "react-modal";
import * as _ from "lodash";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import isEmpty from "lodash/isEmpty";
import { connect } from "react-redux";
import { withAlert } from "react-alert";
import "react-datepicker/dist/react-datepicker.css";
import "react-day-picker/lib/style.css";
import { DatePickerInput } from "rc-datepicker";
import { bindActionCreators } from "redux";
import { Button } from "@material-ui/core";
import {
  getAllVehicleYear,
  getTotalFundSettlement,
  getAllVehicleMake,
  getAllVehicleModel,
  getAllVehicleTrim,
  addVehicleData,
  getAllVehicleDataByUserId,
  deleteVehicleRecordsData,
  viewVehicleEditRecord,
  updateAutoSettlementFlag,
  getConsumerUser,
  tutorialPopupStateAction4,
  tutorialPopupStateAction3,
} from "../../Actions/actions";
import SettlementDetail from "../Tutorial/settlementTutorial";
// import TextFieldGroup from '../common/TextFieldGroup';
// import dashimg from '../../images/dash-img1.png';

import tutorialCimg1 from "../../images/Welcome-Step-1-B2C---V_4.png";
import tutorialBimg1 from "../../images/Welcome---Slide-1-B2b-V_4.png";

import tutorialCimg2 from "../../images/Step-2--B2C-V_4.png";
import tutorialBimg2 from "../../images/Step-2-B2B-V_4.png";

import tutorialCimg3 from "../../images/Step-3-B2C-V_4.png";
import tutorialBimg3 from "../../images/Step-3-B2B---V_4.png";

import tutorialCimg4 from "../../images/Step-4-B2C-V_4.png";
import tutorialBimg4 from "../../images/Step-4-B2B-V_4.png";

import tutorialCimg5 from "../../images/Step-5-B2C-V_5.png";
import tutorialBimg5 from "../../images/Step-5-B2b---V_4.png";

import tutorialBimg6 from "../../images/Step-6-B2B---V_5.png";
import loader from "../../images/Spin-1s-107px.gif";
import QuesStub from "../common/quesStub";
import PlanStub from "../common/planStub";
import BigMoney from "../common/bigMoney";
import TextFieldGroupVin from "../common/vinTextField";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
    
  },
};

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpenVehicle: false,
      modalIsOpenVehicleDelete: false,
      userId: "",
      yearId: "",
      makeId: "",
      modelId: "",
      trimId: "",
      startDate: "",
      endDate: null,
      vin: "",
      errors: {},
      vehicleUserData1: [],
      showButton1: false,
      addVehicle1: [],
      vehicleCostId: "",
      vehicleTypeId: "",
      settlementLiData: [],
      promotedSettlementData: [],
      featureSettlementLiData: [],
      attentionSettlementLiData: [],
      completeSettlementLiData : [],
      allEnrichmentQuestionLiData: [],
      enrollSettlementForUserLiData: [],
      settlementCount: 0,
      featureCount: 0,
      attentionCount: 0,
      enrollSettlementCount: 0,
      questionCount: 0,
      questionInc: 0,
      openTutorial1Dialog: false,
      openTutorial2Dialog: false,
      openTutorial3Dialog: false,
      openTutorial5Dialog: false,
      openTutorial4Dialog: false,
      openTutorial7Dialog: false,
      openTutorial8Dialog: false,
      openInfoDialog: false,
      signInCount: "",
      value: 0,
      mixData: [],
      signInCount1: 1,
      recursive: false,
      disabledDay: false,
      // userNameDisplay: '',
      roleName: localStorage.getItem("roleName"),
      showStaticData: true,
      checkYear: new Date().getFullYear(),
      VehiclesCancel: localStorage.getItem("VehiclesCancel"),
      autoUdateUserSuccess: [],
    };
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {},
      errorsTermPolicy: {},
      errorsCompany: {},
    });
  }

  onViewAllTrigger = () => {
    this.context.router.history.push("/");
    this.context.router.history.push("/settlement");
  };

  componentWillMount() {
    const signInCount = localStorage.getItem("signInCount");

    const userId = localStorage.getItem("userId");
    this.props.getConsumerUser(userId);
    this.setState({
      signInCount,
    });
    localStorage.setItem("signInCount", "2");
  }

  componentDidMount() {
    // if (localStorage.getItem('showTutorial')) {
    //   this.setState({ openTutorial1Dialog: true }, () => {
    //     localStorage.removeItem('showTutorial');
    //   });
    // }
    if (this.props.data.tutorialPopupStateAction3.tutorialPopupState3 == true) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }

    this.props.getAllVehicleYear();
    this.props.getTotalFundSettlement();
  }

  handleClickOutside = () => {
    if(localStorage.getItem("roleName") == "Business-User") {
      if(localStorage.getItem("email") && this.props.data.tutorialPopupStateAction3.tutorialPopupState3 == true && this.props.data.tutorialPopupStateAction2.tutorialPopupState2 == false) {
        this.props.tutorialPopupStateAction3({ tutorialPopupState3: false });
        this.props.tutorialPopupStateAction4({ tutorialPopupState4: true });
      }
    }else {
      if(localStorage.getItem("email") && this.props.data.tutorialPopupStateAction3.tutorialPopupState3 == true) {
        if(window.innerWidth > 376 && window.innerWidth < 415){
          window.scroll({
            top: 1200,
            left: 1,
            behavior: 'smooth'
          });
        }
        else if(window.innerWidth > 415){
          window.scroll({
            top: 400,
            left: 600,
            behavior: 'smooth'
          });  
        }
        this.props.tutorialPopupStateAction3({ tutorialPopupState3: false });
        this.props.tutorialPopupStateAction4({ tutorialPopupState4: true });
      }
    }

  };



  handleClose = () => {
    this.setState({ openTutorial1Dialog: false });
  };

  handleCloseDialogueInfo = () => {
    this.setState({ openInfoDialog: false, openTutorial2Dialog: false });
  };

  handleCloseTutorial2 = () => {
    this.setState({ openTutorial2Dialog: false });
  };

  handleCloseTutorial3 = () => {
    this.setState({ openTutorial3Dialog: false });
  };

  handleCloseTutorial5 = () => {
    this.setState({
      openTutorial5Dialog: false,
      openTutorial7Dialog: false,
      openTutorial8Dialog: false,
    });
  };

  handleCloseTutorial4 = () => {
    this.setState({ openTutorial4Dialog: false });
  };

  handleCloseTutorial7 = () => {
    this.setState({ openTutorial7Dialog: false });
  };

  handleCloseTutorial8 = () => {
    this.setState({ openTutorial8Dialog: false });
  };

  openTutorial2 = () => {
    this.setState({
      openTutorial2Dialog: true,
      openTutorial1Dialog: false,
      openInfoDialog: false,
    });
  };

  openTutorial3 = () => {
    this.setState({ openTutorial2Dialog: false, openTutorial3Dialog: true });
  };

  openTutorial4 = () => {
    this.setState({ openTutorial3Dialog: false, openTutorial4Dialog: true });
  };

  openTutorial5 = () => {
    this.setState({ openTutorial3Dialog: false, openTutorial5Dialog: true });
  };

  openTutorialC6 = () => {
    this.setState({ openTutorial7Dialog: false, openTutorial4Dialog: true });
  };

  openTutorialB6 = () => {
    this.setState({ openTutorial7Dialog: false, openTutorial8Dialog: true });
  };

  openTutorial7 = () => {
    this.setState({ openTutorial5Dialog: false, openTutorial7Dialog: true });
  };

  openTutorial8 = () => {
    this.setState({ openTutorial8Dialog: false, openTutorial4Dialog: true });
  };

  openDialogInfo = () => {
    this.setState({ openInfoDialog: true, openTutorial2Dialog: false });
  };

  handleChangeDialogueInfo = (event, value) => {
    this.setState({ value });
  };

  handleLog(jsDate) {
    const soldNew = moment(jsDate).format("YYYY-MM-DD");
    const purchaseNew = moment(this.state.startDate).format("YYYY-MM-DD");
    if (purchaseNew < soldNew) {
      this.setState({
        endDate: jsDate,
      });
    } else {
      this.setState({
        endDate: null,
      });
    }
  }

  handleLog1(jsDate) {
    const purchaseNew = moment(jsDate);
    const soldNew = moment(this.state.endDate);
    if (purchaseNew > soldNew) {
      this.setState({
        endDate: null,
      });
    } else {
      this.setState({
        startDate: jsDate,
      });
    }
  }

  getStateData = () => {
    this.setState({ recursive: true });
  };

  handleChangeCounter = () => {
    const userId = localStorage.getItem("userId");
    this.setState({ showStaticData: false });
    this.props.saveDataVehicle();
    this.props.updateAutoSettlementFlag({
      userId,
      autoSettlementFlag: "N",
    });
  };

  validateInputData(data) {
    const errors = {};
    if (!data.yearId) {
      errors.yearId = "Year is Required";
      errors.yearIdError = true;
    }
    if (!data.makeId) {
      errors.makeId = "Make is Required";
      errors.makeIdError = true;
    }
    if (!data.modelId) {
      errors.modelId = "Model is Required";
      errors.modelIdError = true;
    }
    if (data.vin.length > 17) {
      errors.vin = "vim maxmum length should be 17 characters";
      errors.vinError = true;
    }
    
    

    return {
      errors,
      isValidData: isEmpty(errors),
    };
  }

  TheLayerUpAnswerstoQuestions = (data) => {
    this.props.answerToQuestionAction(data);
  };

  requestDismissSettlementAction = (data) => {
    // console.log('rajnikant', data);
    this.props.requestDismissSettlementActionToClick(data);
  };

  openModalVehicleCancel() {
    // localStorage.setItem('VehiclesCancel', '2');
    this.setState({ signInCount1: 2 });
  }

  typeSelect(e) {
    if (e.value === "Still Own") {
      this.setState({ disabledDay: "disabled" });
    } else {
      this.setState({ disabledDay: "" });
    }

    this.setState({ vehicleTypeId: e.value, errors: {} });
  }

  isValidData() {
    const { errors, isValidData } = this.validateInputData(this.state);

    if (!isValidData) {
      this.setState({ errors });
    }
    return isValidData;
  }

  openhideVehicle() {
    this.setState({ showStaticData: false });
  }

  _yearSelect(e) {
    let newYear;
    this.setState({ yearId: e.value, errors: {} });
    this.props.getAllVehicleMake(e.value);
    if (e.value !== "") {
      newYear = new Date().getFullYear() - e.value;
      this.setState({ checkYear: newYear, startDate: "", endDate: null });
    } else {
      this.setState({
        checkYear: new Date().getFullYear(),
        startDate: "",
        endDate: null,
      });
    }
  }

  _costSelect(e) {
    this.setState({ vehicleCostId: e.value, errors: {} });
  }

  _trimSelect(e) {
    this.setState({ trimId: e.value, errors: {} });
  }

  _makeYearSelect(e) {
    this.setState({ makeId: e.value, errors: {} });
    const data = {
      vehicleYear: this.state.yearId,
      vehicleMake: e.value,
    };
    this.props.getAllVehicleModel(data);
  }

  handleSubmitVehicle(e) {
    e.preventDefault();
    if (this.isValidData()) {
      this.setState({ errors: {}, isLoading: true });
      this.props.addVehicleData(this.state);
    }
  }

  _modelSelect(e) {
    this.setState({ modelId: e.value, errors: {} });
    const data = {
      vehicleYear: this.state.yearId,
      vehicleMake: this.state.makeId,
      vehicleModel: e.value,
    };
    this.props.getAllVehicleTrim(data);
  }

  closeModalVehicle() {
    this.setState({ modalIsOpenVehicle: false });
  }

  openModalVehicle() {
    this.setState({
      modalIsOpenVehicle: true,
      showButton1: true,
      showUpadeButtonR: false,
      yearId: "",
      makeId: "",
      modelId: "",
      trimId: "",
      startDate: "",
      endDate: null,
      vin: "",
      errors: {},
      disabledDay: "",
      vehicleCostId: "",
      vehicleTypeId: "",
    });
  }

  planStub = (item, questionToDO, promotedSettlement, index) => {
    const date = item.settlementImportantDateDto.claimPeriodEnd;
    return (
      <span key={`s1${item.id}`}>
        <PlanStub
          name={item.shortName}
          dashboardIntroText={item.dashboardIntroText}
          enrId={item.id}
          price={item.totalMoneyAvailable}
          tbdAmount={item.tbdAmount}
          settlingDefendants={item.settlingDefendants}
          item={item}
          applyButtonDisplay
          cat="promotoSettlementData"
          isShow
          claimPeriodEndDate={date}
          hideClaimPeriodEnd={
            item.settlementImportantDateDto.hideClaimPeriodEnd
          }
          dismissOption
          requestDismissSettlement={this.requestDismissSettlementAction}
          sendData={this.getStateData}
          questionToDO={questionToDO}
          AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
          applySettelment={promotedSettlement.remainingSettlement}
        />
      </span>
    );
  };

  componentWillReceiveProps(nextProps) {
    const confrimSettlement = nextProps.data.receiveDismissSettlement;
    if (typeof confrimSettlement !== "undefined") {
      if (confrimSettlement.code === 200) {
        if (this.state.recursive === true) {
          this.setState({ recursive: false });
        }
      }
    }

    const allSettlementData = nextProps.allSettlementData
      ? nextProps.allSettlementData
      : {};
    const promotedSettlement = nextProps.promotedSettlement
      ? nextProps.promotedSettlement
      : {};
    const getDashboardData = nextProps.getDashboardData
      ? nextProps.getDashboardData
      : {};
    const getDashboardDataCount = nextProps.getDashboardDataCount
      ? nextProps.getDashboardDataCount
      : {};

    // getDashboardDataCount
    const featureSettlementData = nextProps.featureSettlementData
      ? nextProps.featureSettlementData
      : {};
    const attentionSettlementData = nextProps.attentionSettlementData
      ? nextProps.attentionSettlementData
      : {};
    const completeSettlementData = nextProps.completeSettlementData
      ? nextProps.completeSettlementData
      : {};
    const allEnrichmentQuestionData = nextProps.allEnrichmentQuestionData
      ? nextProps.allEnrichmentQuestionData
      : {};
    const enrollSettlementForUserData = nextProps.enrollSettlementForUserData
      ? nextProps.enrollSettlementForUserData
      : {};
    const userDataInfo =
      nextProps.data &&
      nextProps.data.ConsumerUserData &&
      nextProps.data.ConsumerUserData.autoSettlementFlag !== undefined
        ? nextProps.data.ConsumerUserData.autoSettlementFlag
        : "N";

    const allSettlementDataHtml = [];
    const promotedSettlementHtml = [];
    const featureSettlementDataHtml = [];
    const attentionSettlementDataHtml = [];
    const completeSettlementDataHtml = [];
    const allEnrichmentQuestionDataHtml = [];
    const enrollSettlementForUserDataHtml = [];
    const mixUserDataHtml = [];
    let sCount1 = 0;

    if (getDashboardDataCount.result !== undefined) {
      if (promotedSettlement !== "undefined") {
        if (
          Object.keys(promotedSettlement).length > 0 &&
          promotedSettlement.code !== 400
        ) {
          let i = 0;
          sCount1 = getDashboardDataCount.result.promotedSettlementCount;
          promotedSettlement.records.map((item, index) => {
            const questionsList = item.eligibilityQuestionDtoList;
            const documentRequired = item.settlementRequiredDocumentDtoList;
            let questionToDO = [];
            if (questionsList.length === 1 && documentRequired.length === 0) {
              questionToDO = questionsList;
            }
            if (i < 5) {
              promotedSettlementHtml.push(
                this.planStub(item, questionToDO, promotedSettlement)
              );
            }

            // if (i === 0) {
            //   mixUserDataHtml.push(this.planStub(item, questionToDO, promotedSettlement, index));
            // }

            return i++;
          });
        }
      }
    }
    // let allSettlementDataIndex = 0;

    if (getDashboardData !== undefined) {
      if (getDashboardData.result !== undefined) {
        if (getDashboardData.result.allSettlementData.length > 0) {
          if (getDashboardData.result.staticSettlementFlag === "Y") {
            if (this.state.roleName === "Consumer" && userDataInfo === "Y") {
              mixUserDataHtml.push(
                <span key="m10">
                  <PlanStub
                    name="Automotive Settlements"
                    dashboardIntroText="We see tons of automotive settlements here at Collectively. Let’s see if you qualify for any of them."
                    enrId="hide"
                    price={getDashboardData.result.totalAutomotiveFund}
                    tbdAmount=""
                    settlingDefendants="We see tons of automotive settlements here at Collectively. Let’s see if you qualify for any of them."
                    item=""
                    applyButtonDisplay
                    cat="automotiveSettlements"
                    isShow
                    claimPeriodEndDate=""
                    dismissOption
                    requestDismissSettlement={
                      this.requestDismissSettlementAction
                    }
                    sendData={this.getStateData}
                    AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
                    automotiveSettlements="automotiveSettlements"
                    change={this.handleChangeCounter}
                    applySettelment={allSettlementData.remainingSettlement}
                  />
                </span>
              );
            }
          }
          let cat = "";
          let applyButtonDisplay = false;
          getDashboardData.result.allSettlementData.map((item, index) => {
            const questionsList = item.eligibilityQuestionDtoList;
            let questionToDO = [];
            if (questionsList.length === 1) {
              questionToDO = questionsList;
            }
            switch (item.settlementPriority) {
              case "newSettlement":
                cat = "allSettlementData";
                applyButtonDisplay = true;
                break;
              case "needAttention":
                cat = "attentionSettlementData";
                applyButtonDisplay = false;
                break;
              case "completed":
                cat = "completeSettlementData";
                applyButtonDisplay = false;
                break;
              case "featured":
                cat = "promotoSettlementData";
                applyButtonDisplay = true;
                break;
              case "inProgress":
                cat = "enrollSettlementForUserData";
                applyButtonDisplay = false;
                break;

              default:
            }
            const date = item.settlementImportantDateDto.claimPeriodEnd;
            const hideClaimPeriodEnd =
              item.settlementImportantDateDto.hideClaimPeriodEnd;
            mixUserDataHtml.push(
              <span key={`m1allSettlementDataIndex${index}`}>
                <PlanStub
                  name={item.shortName}
                  dashboardIntroText={item.dashboardIntroText}
                  enrId={item.id}
                  index={index}
                  price={item.totalMoneyAvailable}
                  tbdAmount={item.tbdAmount}
                  settlingDefendants={item.settlingDefendants}
                  item={item}
                  applyButtonDisplay={applyButtonDisplay}
                  cat={cat}
                  // cat="allSettlementData"
                  isShow
                  claimPeriodEndDate={date}
                  hideClaimPeriodEnd={hideClaimPeriodEnd}
                  dismissOption={
                    item.settlementPriority === "newSettlement" ||
                    item.settlementPriority === "featured"
                  }
                  requestDismissSettlement={this.requestDismissSettlementAction}
                  sendData={this.getStateData}
                  questionToDO={
                    item.settlementPriority === "newSettlement" ||
                    item.settlementPriority === "promotoSettlementData"
                      ? questionToDO
                      : []
                  }
                  AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
                  applySettelment={getDashboardData.result.remainingSettlement}
                  // requiredDoc={item.settlementPriority === 'attentionSettlementData' && item.mandatoryQuestionAnswered === true ? (item.settlementPriority === 'needAttentionSettlemnt' || item.settlementPriority === 'enrollSettlementForUserData' || item.settlementPriority === 'attentionSettlementData' || (item.settlementPriority === 'needAttention' && (item.settlementDocumentDtoList.length > 0 || item.settlementRequiredDocumentDtoList.length > 0))) ? 'upload' : '' : ''}
                  // settlementDocumentDtoList={item.settlementDocumentDtoList || []}
                  requiredDoc={
                    item.mandatoryQuestionAnswered === true
                      ? item.requiredDoc
                      : ""
                  }
                  type={
                    item.settlementPriority === "needAttentionSettlemnt" ||
                    item.settlementPriority === "inProgress" ||
                    item.settlementPriority === "enrollSettlementForUserData" ||
                    item.settlementPriority === "attentionSettlementData" ||
                    item.settlementPriority === "completeSettlementData" ||
                    item.settlementPriority === "needAttention"
                      ? "enrollment"
                      : ""
                  }
                  // applySettelment={getDashboardData.result[iteam.split('-')[1]].remainingSettlement}
                  // requiredDoc={(iteam.split('-')[1] === 'needAttentionSettlemnt' || iteam.split('-')[1] === 'enrollSettlementForUserData') ? getDashboardData.result[iteam.split('-')[1]].requiredDoc : ''}
                />
              </span>
            );
            return true;
          });
        }
        // }

        // getDashboardData.result.prioritySettlement.map((iteam) => {
        //   if (mixUserDataHtml.length <= 3) {
        //     if (iteam.split('-')[1] === 'autoSettleemnt') {
        //       if (getDashboardData.result.staticSettlementFlag === 'Y') {
        //         if (this.state.roleName === 'Consumer' && userDataInfo === 'Y' && this.state.showStaticData === true) {
        //           mixUserDataHtml.push(
        //             <span key="m10">
        //               <PlanStub
        //                 name="Automotive Settlements"
        //                 dashboardIntroText="We see tons of automotive settlements here at Collectively. Let’s see if you qualify for any of them."
        //                 enrId="hide"
        //                 price="2.4b"
        //                 settlingDefendants="We see tons of automotive settlements here at Collectively. Let’s see if you qualify for any of them."
        //                 item=""
        //                 applyButtonDisplay
        //                 cat="automotiveSettlements"
        //                 isShow
        //                 claimPeriodEndDate=""
        //                 dismissOption
        //                 requestDismissSettlement={this.requestDismissSettlementAction}
        //                 sendData={this.getStateData}
        //                 AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
        //                 automotiveSettlements="automotiveSettlements"
        //                 change={this.handleChangeCounter}
        //                 applySettelment={allSettlementData.remainingSettlement}
        //               />
        //             </span>,
        //           );
        //         }
        //       }
        //     } else if (Array.isArray(getDashboardData.result[iteam.split('-')[1]]) === false) {
        //       if (Object.keys(getDashboardData.result[iteam.split('-')[1]]).length > 0) {
        //         const questionsList = getDashboardData.result[iteam.split('-')[1]].eligibilityQuestionDtoList;
        //         let questionToDO = [];
        //         if (questionsList.length === 1) {
        //           questionToDO = questionsList;
        //         }
        //         mixUserDataHtml.push(
        //           <span key={`m2${mixUserDataHtml.length}`}>
        //             <PlanStub
        //               name={getDashboardData.result[iteam.split('-')[1]].shortName}
        //               dashboardIntroText={getDashboardData.result[iteam.split('-')[1]].dashboardIntroText}
        //               enrId={getDashboardData.result[iteam.split('-')[1]].id}
        //               price={getDashboardData.result[iteam.split('-')[1]].totalMoneyAvailable}
        //               settlingDefendants={getDashboardData.result[iteam.split('-')[1]].settlingDefendants}
        //               item={getDashboardData.result[iteam.split('-')[1]]}
        //               applyButtonDisplay={(iteam.split('-')[1] !== 'needAttentionSettlemnt' || iteam.split('-')[1] !== 'enrollSettlementForUserData')}
        //               cat={iteam.split('-')[1]}
        //               isShow
        //               type={(iteam.split('-')[1] === 'needAttentionSettlemnt' || iteam.split('-')[1] === 'enrollSettlementForUserData') ? 'enrollment' : ''}
        //               claimPeriodEndDate={getDashboardData.result[iteam.split('-')[1]].settlementImportantDateDto.claimPeriodEnd}
        //               dismissOption={!((iteam.split('-')[1] === 'needAttentionSettlemnt' || iteam.split('-')[1] === 'enrollSettlementForUserData' || iteam.split('-')[1] === 'attentionSettlementData'))}
        //               requestDismissSettlement={this.requestDismissSettlementAction}
        //               sendData={this.getStateData}
        //               questionToDO={(iteam.split('-')[1] === 'needAttentionSettlemnt' || iteam.split('-')[1] === 'attentionSettlementData') ? [] : questionToDO}
        //               AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
        //               applySettelment={getDashboardData.result[iteam.split('-')[1]].remainingSettlement}
        //               requiredDoc={(iteam.split('-')[1] === 'needAttentionSettlemnt' || iteam.split('-')[1] === 'enrollSettlementForUserData' || iteam.split('-')[1] === 'attentionSettlementData') ? 'upload' : ''}
        //               // requiredDoc={(iteam.split('-')[1] === 'needAttentionSettlemnt' || iteam.split('-')[1] === 'enrollSettlementForUserData') ? getDashboardData.result[iteam.split('-')[1]].requiredDoc : ''}
        //             />
        //           </span>,

        //         );
        //       }
        //     } else {
        //       // getDashboardData.result[iteam.split('-')[1]].map((item, index) => {
        //       const questionsList = getDashboardData.result[iteam.split('-')[1]][allSettlementDataIndex].eligibilityQuestionDtoList;
        //       let questionToDO = [];
        //       if (questionsList.length === 1) {
        //         questionToDO = questionsList;
        //       }
        //       const date = getDashboardData.result[iteam.split('-')[1]][allSettlementDataIndex].settlementImportantDateDto.claimPeriodEnd;
        //       mixUserDataHtml.push(
        //         <span key={`m1allSettlementDataIndex${allSettlementDataIndex}`}>
        //           <PlanStub
        //             name={getDashboardData.result[iteam.split('-')[1]][allSettlementDataIndex].shortName}
        //             dashboardIntroText={getDashboardData.result[iteam.split('-')[1]][allSettlementDataIndex].dashboardIntroText}
        //             enrId={getDashboardData.result[iteam.split('-')[1]][allSettlementDataIndex].id}
        //             price={getDashboardData.result[iteam.split('-')[1]][allSettlementDataIndex].totalMoneyAvailable}
        //             settlingDefendants={getDashboardData.result[iteam.split('-')[1]][allSettlementDataIndex].settlingDefendants}
        //             item={getDashboardData.result[iteam.split('-')[1]][allSettlementDataIndex]}
        //             applyButtonDisplay
        //             cat="allSettlementData"
        //             isShow
        //             claimPeriodEndDate={date}
        //             dismissOption
        //             requestDismissSettlement={this.requestDismissSettlementAction}
        //             sendData={this.getStateData}
        //             questionToDO={questionToDO}
        //             AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
        //             applySettelment={allSettlementData.remainingSettlement}
        //           />
        //         </span>,
        //       );
        //       if (iteam.split('-')[1] === 'allSettlementData') {
        //         allSettlementDataIndex++;
        //       }
        //       //   return true;
        //       // });
        //     }
        //   }

        //   return true;
        // });
      }
    }
    let sCount = 0;
    if (getDashboardDataCount.result !== undefined) {
      if (allSettlementData !== "undefined") {
        if (
          Object.keys(allSettlementData).length > 0 &&
          allSettlementData.code !== 400
        ) {
          let i = 0;
          sCount = getDashboardDataCount.result.newSettlementCount;
          allSettlementData.records.map((item, index) => {
            const questionsList = item.eligibilityQuestionDtoList;
            let questionToDO = [];
            if (questionsList.length === 1) {
              questionToDO = questionsList;
            }
            const date = item.settlementImportantDateDto.claimPeriodEnd;
            if (i < 5) {
              allSettlementDataHtml.push(
                <span key={`s2${index}`}>
                  <PlanStub
                    name={item.shortName}
                    dashboardIntroText={item.dashboardIntroText}
                    enrId={item.id}
                    price={item.totalMoneyAvailable}
                    tbdAmount={item.tbdAmount}
                    settlingDefendants={item.settlingDefendants}
                    item={item}
                    applyButtonDisplay
                    cat="allSettlementData"
                    isShow={false}
                    claimPeriodEndDate={date}
                    hideClaimPeriodEnd={
                      item.settlementImportantDateDto.hideClaimPeriodEnd
                    }
                    dismissOption
                    requestDismissSettlement={
                      this.requestDismissSettlementAction
                    }
                    sendData={this.getStateData}
                    questionToDO={questionToDO}
                    AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
                    applySettelment={allSettlementData.remainingSettlement}
                  />
                </span>
              );
            }

            // if (this.state.roleName === 'Consumer' && userDataInfo === 'Y' && this.state.showStaticData === true) {
            //   if (i < 1) {
            //     mixUserDataHtml.push(
            //       <span key={`m1${index}`}>
            //         <PlanStub
            //           name="Automotive Settlements"
            //           dashboardIntroText="We see tons of automotive settlements here at Collectively. Let’s see if you qualify for any of them."
            //           enrId="hide"
            //           price="468m"
            //           settlingDefendants="We see tons of automotive settlements here at Collectively. Let’s see if you qualify for any of them."
            //           item={item}
            //           applyButtonDisplay
            //           cat="automotiveSettlements"
            //           isShow
            //           claimPeriodEndDate={date}
            //           dismissOption
            //           requestDismissSettlement={this.requestDismissSettlementAction}
            //           sendData={this.getStateData}
            //           AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
            //           automotiveSettlements="automotiveSettlements"
            //           change={this.handleChangeCounter}
            //           applySettelment={allSettlementData.remainingSettlement}
            //         />
            //       </span>,
            //     );
            //   }
            // }

            // let mixUserDataHtmlCounter = 3;
            // if (this.state.roleName === 'Consumer' && this.state.signInCount === '1') {
            //   mixUserDataHtmlCounter = 2;
            // }
            // if (i < mixUserDataHtmlCounter) {
            //   mixUserDataHtml.push(
            //     <span key={`m2${index}`}>
            //       <PlanStub
            //         name={item.shortName}
            //         dashboardIntroText={item.dashboardIntroText}
            //         enrId={item.id}
            //         price={item.totalMoneyAvailable}
            //         settlingDefendants={item.settlingDefendants}
            //         item={item}
            //         applyButtonDisplay
            //         cat="allSettlementData"
            //         isShow
            //         claimPeriodEndDate={date}
            //         dismissOption
            //         requestDismissSettlement={this.requestDismissSettlementAction}
            //         sendData={this.getStateData}
            //         questionToDO={questionToDO}
            //         AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
            //         applySettelment={allSettlementData.remainingSettlement}
            //       />
            //     </span>,
            //   );
            // }

            return i++;
          });
        }
      }
    }
    // if (getDashboardDataCount.result !== undefined) {

    if (featureSettlementData !== "undefined") {
      if (
        Object.keys(featureSettlementData).length > 0 &&
        featureSettlementData.code !== 400
      ) {
        let i = 0;
        featureSettlementData.map((item, index) => {
          const questionsList = item.eligibilityQuestionDtoList;
          const documentRequired = item.settlementRequiredDocumentDtoList;
          let questionToDO = [];
          if (questionsList.length === 1 && documentRequired.length === 0) {
            questionToDO = questionsList;
          }
          if (i < 5) {
            featureSettlementDataHtml.push(
              <span key={`a${index}`}>
                <PlanStub
                  name={item.shortName}
                  dismissOption={false}
                  requestDismissSettlement={this.requestDismissSettlementAction}
                  dashboardIntroText={item.dashboardIntroText}
                  enrId={item.id}
                  price={item.totalMoneyAvailable}
                  tbdAmount={item.tbdAmount}
                  settlingDefendants={item.settlingDefendants}
                  item={item}
                  applyButtonDisplay
                  cat="featureSettlementData"
                  isShow={false}
                  claimPeriodEndDate={
                    item.settlementImportantDateDto.claimPeriodEndDate
                  }
                  hideClaimPeriodEnd={
                    item.settlementImportantDateDto.hideClaimPeriodEnd
                  }
                  sendData={this.getStateData}
                  questionToDO={questionToDO}
                  AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
                  applySettelment={allSettlementData.remainingSettlement}
                />
              </span>
            );
          }
          // if (i === 0) {
          //   mixUserDataHtml.push(
          //     <span key={`m3${index}`}>
          //       <PlanStub
          //         name={item.shortName}
          //         dismissOption={false}
          //         requestDismissSettlement={this.requestDismissSettlementAction}
          //         dashboardIntroText={item.dashboardIntroText}
          //         enrId={item.id}
          //         price={item.totalMoneyAvailable}
          //         settlingDefendants={item.settlingDefendants}
          //         settlement={item}
          //         applyButtonDisplay={false}
          //         cat="featureSettlementData"
          //         isShow
          //         claimPeriodEndDate={item.settlementImportantDateDto.claimPeriodEndDate}
          //         sendData={this.getStateData}
          //         questionToDO={questionToDO}
          //         AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
          //       />
          //     </span>,
          //   );
          // }
          return i++;
        });
      }
    }
    if (attentionSettlementData !== "undefined") {
      if (
        Object.keys(attentionSettlementData).length > 0 &&
        attentionSettlementData.code !== 400
      ) {
        let i = 0;
        attentionSettlementData.map((item, index) => {
          if (i < 5) {
            attentionSettlementDataHtml.push(
              <span key={`a2${index}`}>
                <PlanStub
                  name={item.settlementDto.shortName}
                  dismissOption={false}
                  requestDismissSettlement={this.requestDismissSettlementAction}
                  dashboardIntroText={item.settlementDto.dashboardIntroText}
                  enrId={item.settlementDto.id}
                  price={item.settlementDto.totalMoneyAvailable}
                  tbdAmount={item.settlementDto.tbdAmount}
                  settlingDefendants={item.settlementDto.settlingDefendants}
                  item={item.settlementDto}
                  applyButtonDisplay
                  cat="attentionSettlementData"
                  isShow={false}
                  sendData={this.getStateData}
                  claimPeriodEndDate={
                    item.settlementDto.settlementImportantDateDto.claimPeriodEnd
                  }
                  hideClaimPeriodEnd={
                    item.settlementDto.settlementImportantDateDto
                      .hideClaimPeriodEnd
                  }
                  type="enrollment"
                  questionToDO={[]}
                  AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
                  requiredDoc={
                    item.mandatoryQuestionAnswered === true
                      ? item.requiredDoc
                      : ""
                  }
                />
              </span>
            );
          }
          // if (i === 0) {
          //   mixUserDataHtml.push(
          //     <span key={`m4${index}`}>
          //       <PlanStub
          //         name={item.settlementDto.shortName}
          //         dismissOption={false}
          //         requestDismissSettlement={this.requestDismissSettlementAction}
          //         dashboardIntroText={item.settlementDto.dashboardIntroText}
          //         enrId={item.settlementDto.id}
          //         price={item.settlementDto.totalMoneyAvailable}
          //         settlingDefendants={item.settlingDefendants}
          //         item={item.settlementDto}
          //         applyButtonDisplay
          //         cat="attentionSettlementData"
          //         isShow
          //         sendData={this.getStateData}
          //         claimPeriodEndDate={item.settlementDto.settlementImportantDateDto.claimPeriodEnd}
          //         questionToDO={[]}
          //         AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
          //         requiredDoc={item.requiredDoc}
          //       />
          //     </span>,
          //   );
          // }
          return i++;
        });
      }
    }
    if (completeSettlementData !== "undefined") {
      if (
        Object.keys(completeSettlementData).length > 0 &&
        completeSettlementData.code !== 400
      ) {
        let i = 0;
        completeSettlementData.map((item, index) => {
          if (i < 5) {
            console.log("html",completeSettlementData)
            completeSettlementDataHtml.push(
              <span key={`a2${index}`}>
                <PlanStub
                  name={item.settlementDto.shortName}
                  dismissOption={false}
                  // requestDismissSettlement={this.requestDismissSettlementAction}
                  dashboardIntroText={item.settlementDto.dashboardIntroText}
                  enrId={item.settlementDto.id}
                  price={item.settlementDto.totalMoneyAvailable}
                  tbdAmount={item.settlementDto.tbdAmount}
                  settlingDefendants={item.settlementDto.settlingDefendants}
                  item={item.settlementDto}
                  // applyButtonDisplay
                  cat="completeSettlementData"
                  isShow={false}
                  // sendData={this.getStateData}
                  claimPeriodEndDate={
                    item.settlementDto.settlementImportantDateDto.claimPeriodEnd
                  }
                  hideClaimPeriodEnd={
                    item.settlementDto.settlementImportantDateDto
                      .hideClaimPeriodEnd
                  }
                  type="enrollment"
                  // questionToDO={[]}
                  // AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
                  // requiredDoc={
                  //   item.mandatoryQuestionAnswered === true
                  //     ? item.requiredDoc
                  //     : ""
                  // }
                  requiredDoc={item.settlementDto.requiredDoc}
                />
                {/* <PlanStub
                    name={item.settlementDto.shortName}
                    dashboardIntroText={item.settlementDto.dashboardIntroText}
                    enrId={item.settlementDto.id}
                    price={item.settlementDto.totalMoneyAvailable}
                    tbdAmount={item.settlementDto.tbdAmount}
                    claimPeriodEndDate={
                      item.settlementDto.settlementImportantDateDto.claimPeriodEnd
                    }
                    disbursedAmount={item.settlementDto.fundsForEnrollment}
                    breakdownFund={item.settlementDto.priceBreakupDto}
                    hideClaimPeriodEnd={
                      item.settlementDto.settlementImportantDateDto.hideClaimPeriodEnd
                    }
                    cat="completeSettlementData"

                    item={item}
                    type="enrollment"
                    requiredDoc={item.settlementDto.requiredDoc}
                  /> */}
              </span>
            );
          }
          // if (i === 0) {
          //   mixUserDataHtml.push(
          //     <span key={`m4${index}`}>
          //       <PlanStub
          //         name={item.settlementDto.shortName}
          //         dismissOption={false}
          //         requestDismissSettlement={this.requestDismissSettlementAction}
          //         dashboardIntroText={item.settlementDto.dashboardIntroText}
          //         enrId={item.settlementDto.id}
          //         price={item.settlementDto.totalMoneyAvailable}
          //         settlingDefendants={item.settlingDefendants}
          //         item={item.settlementDto}
          //         applyButtonDisplay
          //         cat="attentionSettlementData"
          //         isShow
          //         sendData={this.getStateData}
          //         claimPeriodEndDate={item.settlementDto.settlementImportantDateDto.claimPeriodEnd}
          //         questionToDO={[]}
          //         AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
          //         requiredDoc={item.requiredDoc}
          //       />
          //     </span>,
          //   );
          // }
          return i++;
        });
      }
    }
    if (allEnrichmentQuestionData !== "undefined") {
      if (
        Object.keys(allEnrichmentQuestionData).length > 0 &&
        allEnrichmentQuestionData.code !== 400
      ) {
        let i = 0;
        allEnrichmentQuestionData.records.map((item, index) => {
          if (i < 5) {
            allEnrichmentQuestionDataHtml.push(
              <span key={`E${index}`}>
                <QuesStub
                  queText={item.questionText}
                  queId={item.enrichmentQuestionId}
                  onClick={this.enrichmentQuestionAnswer}
                />
              </span>
            );
          }
          return i++;
        });
        this.setState({
          questionCount: Object.keys(allEnrichmentQuestionData).length,
        });
      }
    }

    if (enrollSettlementForUserData !== "undefined") {
      if (
        Object.keys(enrollSettlementForUserData).length > 0 &&
        enrollSettlementForUserData.code !== 400
      ) {
        let i = 0;
        enrollSettlementForUserData.map((item, index) => {
          if (i < 5) {
            enrollSettlementForUserDataHtml.push(
              <span key={`n${index}`}>
                <PlanStub
                  name={item.settlementDto.shortName}
                  dismissOption={false}
                  requestDismissSettlement={this.requestDismissSettlementAction}
                  dashboardIntroText={item.status}
                  enrId={
                    item.settlementDto !== undefined ? item.settlementDto.id : 0
                  }
                  price={
                    item.settlementDto !== undefined
                      ? item.settlementDto.totalMoneyAvailable
                      : 0
                  }
                  tbdAmount={
                    item.settlementDto !== undefined
                      ? item.settlementDto.tbdAmount
                      : ""
                  }
                  item={item.settlementDto}
                  applyButtonDisplay={false}
                  cat="enrollSettlementForUserData"
                  type="enrollment"
                  isShow={false}
                  sendData={this.getStateData}
                  claimPeriodEndDate={
                    item.settlementDto !== undefined
                      ? item.settlementDto.settlementImportantDateDto
                          .claimPeriodEnd
                      : 0
                  }
                  hideClaimPeriodEnd={
                    item.settlementDto !== undefined
                      ? item.settlementDto.settlementImportantDateDto
                          .hideClaimPeriodEnd
                      : 0
                  }
                  questionToDO={[]}
                  AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
                  requiredDoc={item.requiredDoc}
                />
              </span>
            );
          }
          // if (i === 0) {
          //   mixUserDataHtml.push(
          //     <span key={`m5${index}`}>
          //       <PlanStub
          //         name={item.settlementDto.shortName}
          //         dismissOption={false}
          //         requestDismissSettlement={this.requestDismissSettlementAction}
          //         dashboardIntroText={item.status}
          //         enrId={item.settlementDto !== undefined ? item.settlementDto.id : 0}
          //         price={item.settlementDto !== undefined ? item.settlementDto.totalMoneyAvailable : 0}
          //         item={item.settlementDto}
          //         applyButtonDisplay={false}
          //         type="enrollment"
          //         cat="enrollSettlementForUserData"
          //         isShow
          //         sendData={this.getStateData}
          //         claimPeriodEndDate={item.settlementDto !== undefined ? item.settlementDto.settlementImportantDateDto.claimPeriodEnd : 0}
          //         questionToDO={[]}
          //         AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
          //       />
          //     </span>,
          //   );
          // }
          return i++;
        });
      }
    }
    this.setState((state) => ({
      settlementLiData: allSettlementDataHtml,
      promotedSettlementData: promotedSettlementHtml,
      featureSettlementLiData: featureSettlementDataHtml,
      attentionSettlementLiData: attentionSettlementDataHtml,
      completeSettlementLiData : completeSettlementDataHtml,
      allEnrichmentQuestionLiData: allEnrichmentQuestionDataHtml,
      enrollSettlementForUserLiData: enrollSettlementForUserDataHtml,
      mixData: mixUserDataHtml,
      // settlementCount: (state.roleName === 'Consumer' && state.signInCount === '1') ? (state.showStaticData === true) ? sCount + 1 : sCount : sCount,
      settlementCount: sCount,
      featureCount: 0,
      attentionCount: 0,
      enrollSettlementCount: 0,
      promotedSettlementCount: sCount1,
    }));
  }

  enrichmentQuestionAnswer = (queId, ans) => {
    this.setState((state) => ({
      questionInc: state.questionInc + 1,
    }));
    this.props.saveEnrichmentAnswer(queId, ans);
  };

  componentDidUpdate() {
    const { addVehicle, autoUdateUser } = this.props.data;
    const { addVehicle1, autoUdateUserSuccess } = this.state;

    if (addVehicle !== undefined) {
      if (addVehicle1 !== addVehicle) {
        const Count = localStorage.getItem("VehiclesCancel");
        this.setState({
          addVehicle1: addVehicle,
          signInCount1: Count,
        });

        this.closeModalVehicle();
      }
    }
    if (autoUdateUserSuccess !== autoUdateUser) {
      this.setState({
        autoUdateUserSuccess: autoUdateUser,
      });
    }
  }

  render() {
    const {
      startDate,
      endDate,
      roleName,
      yearId,
      errors,
      disabledDay,
      vehicleCostId,
      vehicleTypeId,
      showUpadeButtonR,
      showButton1,
      vin,
      modelId,
      makeId,
      trimId,
      questionInc,
      questionCount,
      featureSettlementLiData,
      attentionSettlementLiData,
      completeSettlementLiData,
      allEnrichmentQuestionLiData,
      enrollSettlementForUserLiData,
      settlementLiData,
      promotedSettlementData,
      mixData,
    } = this.state;
    if(settlementLiData[0] && settlementLiData.length < 1) {
      localStorage.removeItem("showTutorial")
    }
    
    let  loader1 = (
      <div className="loader">
        <img src={loader} alt="" />
      </div>
    );


    const {
      vehicleYear,
      vehicleMoel,
      vehicleTrim,
      vehicleMake,
      fundTotal,
      getDashboardDataCount,
    } = this.props.data;
    const { isLoaderData } = this.props;

    const user = localStorage.getItem("firstName");
    const lastname = localStorage.getItem("lastname");
    let UserName = "";
    if (user) {
      // this.setState({
      UserName = `${user} ${lastname}`;
      // });
    }

    const optionsYear = [];
    optionsYear.push({ value: "", label: "Year", name: "Year" });
    if (vehicleYear !== undefined) {
      vehicleYear.map((item) =>
        optionsYear.push({ value: item, label: item, name: item })
      );
    }

    const cSelectedYear = _.find(optionsYear, { value: yearId });
    const cDefaultOptionYear = cSelectedYear;
    // make
    const optionsMake = [];
    optionsMake.push({ value: "", label: "Make", name: "Make" });
    if (vehicleMake !== undefined) {
      vehicleMake.map((item) =>
        optionsMake.push({ value: item, label: item, name: item })
      );
    }

    const cSelectedMake = _.find(optionsMake, { value: makeId });
    const cDefaultOptionMake = cSelectedMake;

    const optionsModel = [];
    optionsModel.push({ value: "", label: "Model", name: "Model" });

    if (vehicleMoel !== undefined) {
      vehicleMoel.map((item) =>
        optionsModel.push({ value: item, label: item, name: item })
      );
    }
    const cSelectedModel = _.find(optionsModel, { value: modelId });
    const cDefaultOptionModel = cSelectedModel;

    const optionsTrim = [];
    optionsTrim.push({ value: "", label: "Trim", name: "Trim" });

    if (vehicleTrim !== undefined) {
      vehicleTrim.map((item) =>
        optionsTrim.push({
          value: item.vehicleDetailsId,
          label: item.trim,
          name: item.trim,
        })
      );
    }
    const cSelectedTrim = _.find(optionsTrim, { value: trimId });
    const cDefaultOptionTrim = cSelectedTrim;

    const optionsVehicleCost = [];
    optionsVehicleCost.push({ value: "", label: "Select", name: "Select" });
    optionsVehicleCost.push({
      value: "Leased",
      label: "Leased",
      name: "Leased",
    });
    optionsVehicleCost.push({
      value: "Purchased New",
      label: "Purchased New",
      name: "Purchased New",
    });
    optionsVehicleCost.push({
      value: "Purchased Used",
      label: "Purchased Used",
      name: "Purchased Used",
    });

    const cSelectedVehicleCost = _.find(optionsVehicleCost, {
      value: vehicleCostId,
    });
    const cDefaultVehicleCost = cSelectedVehicleCost;

    const optionsVehicleType = [];
    optionsVehicleType.push({ value: "", label: "Select", name: "Select" });
    optionsVehicleType.push({
      value: "Still Own",
      label: "Still Owned",
      name: "Still Owned",
    });
    optionsVehicleType.push({ value: "Sold", label: "Sold", name: "Sold" });

    const cSelectedVehicleType = _.find(optionsVehicleType, {
      value: vehicleTypeId,
    });
    const cDefaultVehicleType = cSelectedVehicleType;

    let question = [];
    if (questionInc === questionCount) {
      question = "";
    } else {
      question = allEnrichmentQuestionLiData[questionInc];
    }
    let dialog1;
    let headerText = "";
    const vehicleIntroText = "";
    if (this.state.signInCount === "1") {
      headerText = (
        <div className="welcome-dashtxt center-align">
          <h3>Welcome to Collectively</h3>
          <p>
            Ready to find your slice of the
            {fundTotal !== undefined ? (
              roleName === "Consumer" ? (
                fundTotal.consumerTotal !== undefined ? (
                  <BigMoney value={fundTotal.consumerTotal} />
                ) : (
                  0
                )
              ) : fundTotal.businessTotal !== undefined ? (
                <BigMoney value={fundTotal.businessTotal} />
              ) : (
                0
              )
            ) : (
              0
            )}{" "}
            in claims available? See how easy it is to get started filing with
            Collectively.
          </p>
        </div>
      );
      dialog1 = (
        <Dialog
          open={this.state.openTutorial1Dialog}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          id="form-1dialog-title"
          className="tutorial-background-color"
          maxWidth="md"
          opacity="0.8"
          disableBackdropClick
        >
          <div id="tutorial-pop" className="tutorial-pop">
            <DialogContent>
              <div className="tutorial-arrow">
                <i className="material-icons">arrow_downward</i>
              </div>
              <p>
                <a className="start-tutorial" onClick={this.openTutorial2}>
                  Lets Get Started
                </a>
              </p>
            </DialogContent>
            <DialogActions />
          </div>
        </Dialog>
      );
    } else {
      // console.log("this.props.userName",this.props.userName)
      headerText = (
        <div className="section-content partner-dashboard">
          <div className="row">
            <div className="welcome-partner">
              <div className="col s12 m12">
                <h4>WELCOME {UserName}</h4>
              </div>
            </div>
          </div>
        </div>
      );
    }

    let featuredSettlementPermission = false;
    let inProgressPermission = roleName === "Consumer";
    let needAttentionPermission = roleName === "Consumer";
    let completedEnrollmentPermission = roleName === "Consumer";
    let EnrichmentQuestionPermission = false;
    const userAccessObj = localStorage.getItem("userAccessObject");
    if (userAccessObj !== "undefined") {
      const userAccessObject = JSON.parse(
        localStorage.getItem("userAccessObject")
      );
      if (
        typeof userAccessObject !== "undefined" &&
        userAccessObject !== null
      ) {
        userAccessObject.map((access) => {
          if (access.planAccessLevelType === "Pre-Enrollment") {
            if (access.levelValues === true) {
              featuredSettlementPermission = true;
            }
          }
          if (access.planAccessLevelType === "In Progress Enrollments") {
            if (access.levelValues === true) {
              inProgressPermission = true;
            }
          }
          if (access.planAccessLevelType === "Need Attention") {
            if (access.levelValues === true) {
              needAttentionPermission = true;
            }
          }
          if (access.planAccessLevelType === "Completed Enrollments") {
            if (access.levelValues === true) {
              completedEnrollmentPermission = true;
            }
          }
          if (access.planAccessLevelType === "Enrichment Questions") {
            EnrichmentQuestionPermission = true;
          }
          return false;
        });
      }
    }

    // userAccessObject
    return (
      <span>
        {this.props.data.tutorialPopupStateAction3.tutorialPopupState3 == true
          ? document.addEventListener("mousedown", this.handleClickOutside)
          : ""}
        <Modal
          shouldCloseOnOverlayClick={false}
          isOpen={this.state.modalIsOpenVehicle}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalVehicle}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
        >
          <div className="modal-content addvehicle-content">
            <div className="col s12 m7">
              <h4> {showButton1 === true ? "Add" : "Update"} Vehicles</h4>
            </div>
            <form>
              <div className="col s12">
                <div className="grey-box">
                  <div className="grey-inner">
                    <div className="input-field half-field padding-field">
                      <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsYear}
                        onChange={this._yearSelect}
                        value={cDefaultOptionYear}
                        placeholder="Select an option"
                      />
                      <span
                        className={errors.yearIdError ? "show invalid" : "hide"}
                      >
                        {errors.yearId}
                      </span>
                    </div>
                    <div className="input-field half-field ">
                      <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsMake}
                        onChange={this._makeYearSelect}
                        value={cDefaultOptionMake}
                        placeholder="Select an option"
                      />
                      <span
                        className={errors.makeIdError ? "show invalid" : "hide"}
                      >
                        {errors.makeId}
                      </span>
                    </div>
                    <div className="input-field half-field padding-field">
                      <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsModel}
                        onChange={this._modelSelect}
                        value={cDefaultOptionModel}
                        placeholder="Select an option"
                      />
                      <span
                        className={
                          errors.modelIdError ? "show invalid" : "hide"
                        }
                      >
                        {errors.modelId}
                      </span>
                    </div>
                    <div className="input-field half-field">
                      <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsTrim}
                        onChange={this._trimSelect}
                        value={cDefaultOptionTrim}
                        placeholder="Select an option"
                      />
                    </div>
                    <div className="input-field half-field padding-field">
                      <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsVehicleCost}
                        onChange={this._costSelect}
                        value={cDefaultVehicleCost}
                        placeholder="Select an option"
                      />
                    </div>
                    <div className="input-field half-field ">
                      <Dropdown
                        name="year"
                        className="browser-default"
                        options={optionsVehicleType}
                        onChange={this._typeSelect}
                        value={cDefaultVehicleType}
                        placeholder="Select an option"
                      />
                    </div>
                    <div className="input-field full-field">
                      <TextFieldGroupVin
                        field="vin"
                        label="vin"
                        value={vin}
                        onChange={this.onChange}
                      />
                    </div>
                    <div className="input-field half-field padding-field">
                      <DatePickerInput
                        showOnInputClick
                        onChange={this.handleLog1}
                        value={startDate}
                        className="my-custom-datepicker-component"
                        autoClose
                        placeholder="Purchase Date"
                        minDate={moment()
                          .subtract(this.state.checkYear, "year")
                          .toDate()}
                        maxDate={moment()}
                        locale="en-au"
                        displayFormat="MM-DD-YYYY"
                        position="top"
                      />
                    </div>
                    <div className="input-field  half-field">
                      <DatePickerInput
                        showOnInputClick
                        onChange={this.handleLog}
                        value={endDate}
                        displayFormat="MM-DD-YYYY"
                        className="my-custom-datepicker-component"
                        autoClose
                        placeholder="Sold Date"
                        minDate={moment()
                          .subtract(this.state.checkYear, "year")
                          .toDate()}
                        maxDate={moment()}
                        disabled={disabledDay}
                        locale="en-au"
                        position="top"
                      />
                    </div>
                    <div className="input-field full-field save-button">
                      <button
                        onClick={this.handleSubmitVehicle}
                        className={
                          showButton1 === true
                            ? "btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                            : "hide"
                        }
                        type="submit"
                        name="action"
                      >
                        Save
                        <i className="material-icons">arrow_forward</i>
                      </button>
                      <button
                        onClick={this.handleUpdateVehicle}
                        className={
                          showUpadeButtonR === true
                            ? "btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                            : "hide"
                        }
                        type="submit"
                        name="action"
                      >
                        Update
                        <i className="material-icons">arrow_forward</i>
                      </button>
                      <button
                        onClick={this.closeModalVehicle}
                        style={{ marginLeft: "5px" }}
                        className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                        type="submit"
                        name="action"
                      >
                        Cancel
                        <i className="material-icons">arrow_forward</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal>

        <div className="abvc">{dialog1}</div>
        <Dialog
          open={this.state.openTutorial2Dialog}
          onClose={this.handleCloseTutorial2}
          aria-labelledby="form-dialog-title"
          id="form-2dialog-title"
          maxWidth="md"
          className="tutorial-background-color"
          disableBackdropClick
        >
          <div id="tutorial-pop">
            <DialogContent>
              <div className="tutorial-onboard">
                <img
                  src={roleName === "Consumer" ? tutorialCimg1 : tutorialBimg1}
                  alt="tutorial-1"
                />
                {/* <div className="tutorial-question center-align">
Want more Information? Simply Click
                    {' '}
                    <span>Settlement Details</span>
                    {' '}
to see all the cases details.
                  </div>
                  <div className="tutorial-detail">
                    <div className="tutorial-arrow">
                      <i className="material-icons">arrow_downward</i>
                    </div>
                    <div className="row ">
                      <div className="col m3 l2">
                        <div className="img-box"><img src={dashimg} alt="dashimg" /></div>
                      </div>
                      <div className="col m6 l7">
                        <h5>
Reddylce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <p>Redylce has a class action suit against it and you could be eligible for reimbursement. Let,s get started:</p>
                      </div>
                      <div className="col m3">
                        <a className="detail">Settlement Details</a>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col m12">
                        <a className="waves-effect waves-light btn btn-blue save-changes">Click Here to Apply</a>
                      </div>
                    </div>
                  </div> */}
              </div>
              <div className="tutorial-btns">
                <a
                  className="waves-effect waves-light btn"
                  onClick={this.handleCloseTutorial2}
                >
                  Skip
                </a>{" "}
                <a
                  onClick={this.openTutorial3}
                  className="waves-effect waves-light btn"
                >
                  Next
                </a>
              </div>
            </DialogContent>
            <DialogActions />
          </div>
        </Dialog>
        <Dialog
          open={this.state.openTutorial3Dialog}
          onClose={this.handleCloseTutorial3}
          aria-labelledby="form-dialog-title"
          id="form-3dialog-title"
          className="tutorial-background-color"
          maxWidth="md"
          disableBackdropClick
        >
          <div id="tutorial-pop">
            <DialogContent>
              <div className="tutorial-onboard">
                <img
                  src={roleName === "Consumer" ? tutorialCimg2 : tutorialBimg2}
                  alt="tutorial-2"
                />

                {/* <div className="tutorial-question center-align">Just answer questions on open cases to check your eligibility</div>
                  <div className="tutorial-detail">
                    <div className="row ">
                      <div className="col m3 l2">
                        <div className="img-box"><img src={dashimg} alt="dashimg" /></div>
                      </div>
                      <div className="col m9 l7">
                        <h5>
Reddylce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <p>Redylce has a class action suit against it and you could be eligible for reimbursement. Let,s get started:</p>
                        <h6>1-Step Enrollment</h6>
                        <span>How many bags of reddyice have you purchased since 2007?</span>
                        <div className="tutorial-pop-btns">
                          <div className="tutorial-arrow2">
                            <i className="material-icons">arrow_forward</i>
                          </div>
                          <a className="waves-effect waves-light btn primary-btn left">0 bags</a>
                          <a className="waves-effect waves-light btn primary-btn left">1-6 bags</a>
                          <a
                            className="waves-effect waves-light btn btn-blue save-changes left"

                          >
7+bags

                          </a>
                        </div>
                      </div>
                    </div>

                  </div> */}
              </div>
              <div className="tutorial-btns">
                <a
                  className="waves-effect waves-light btn"
                  onClick={this.handleCloseTutorial3}
                >
                  Skip
                </a>{" "}
                <a
                  onClick={this.openTutorial5}
                  className="waves-effect waves-light btn"
                >
                  Next
                </a>
              </div>
            </DialogContent>
          </div>
        </Dialog>
        <Dialog
          open={this.state.openTutorial5Dialog}
          onClose={this.handleCloseTutorial5}
          aria-labelledby="form-dialog-title"
          id="form-2dialog-title"
          maxWidth="md"
          className="tutorial-background-color"
          disableBackdropClick
        >
          <div id="tutorial-pop">
            <DialogContent>
              <div className="tutorial-onboard">
                <img
                  src={roleName === "Consumer" ? tutorialCimg3 : tutorialBimg3}
                  alt="tutorial-2"
                />

                {/* <div className="tutorial-question center-align">
                    {' '}
Please click
                    {' '}
                    <i className="material-icons hide-icon">visibility_off</i>
                    {' '}
on the hide option, if the settlement is not relevant to you.
                  </div>
                  <div className="tutorial-detail">

                    <div className="row ">
                      <div className="col m3 l2">
                        <div className="img-box"><img src={dashimg} alt="dashimg" /></div>
                        <div className="tutorial-icons">
                          <span className="hide hide-seetlementtext">Hide&nbsp;</span>
                          <i className="material-icons view-icon">visibility_off</i>
                          <div className="tutorial-arrow">
                            <i className="material-icons">arrow_backward</i>

                          </div>
                        </div>
                      </div>
                      <div className="col m6 l7">
                        <h5>
Reddylce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <p>Redylce has a class action suit against it and you could be eligible for reimbursement. Let,s get started:</p>
                      </div>

                      <div className="col m3">
                        <a className="detail">Settlement Details</a>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col m12">
                        <a className="waves-effect waves-light btn btn-blue save-changes">Click Here to Apply</a>
                      </div>
                    </div>
                  </div> */}
              </div>

              <div className="tutorial-btns">
                <a
                  className="waves-effect waves-light btn"
                  onClick={this.handleCloseTutorial5}
                >
                  Skip
                </a>{" "}
                <a
                  onClick={this.openTutorial7}
                  className="waves-effect waves-light btn"
                >
                  Next
                </a>
              </div>
            </DialogContent>
            <DialogActions />
          </div>
        </Dialog>

        <Dialog
          open={this.state.openTutorial7Dialog}
          onClose={this.handleCloseTutorial7}
          aria-labelledby="form-dialog-title"
          id="form-2dialog-title"
          maxWidth="md"
          className="tutorial-background-color"
          disableBackdropClick
        >
          <div id="tutorial-pop">
            <DialogContent>
              <div className="tutorial-onboard">
                <img
                  src={roleName === "Consumer" ? tutorialCimg4 : tutorialBimg4}
                  alt="tutorial-2"
                />

                {/* <div className="tutorial-question center-align">
                    {' '}
Please click
                    {' '}
                    <i className="material-icons hide-icon">visibility_off</i>
                    {' '}
on the hide option, if the settlement is not relevant to you.
                  </div>
                  <div className="tutorial-detail">

                    <div className="row ">
                      <div className="col m3 l2">
                        <div className="img-box"><img src={dashimg} alt="dashimg" /></div>
                        <div className="tutorial-icons">
                          <span className="hide hide-seetlementtext">Hide&nbsp;</span>
                          <i className="material-icons view-icon">visibility_off</i>
                          <div className="tutorial-arrow">
                            <i className="material-icons">arrow_backward</i>

                          </div>
                        </div>
                      </div>
                      <div className="col m6 l7">
                        <h5>
Reddylce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <p>Redylce has a class action suit against it and you could be eligible for reimbursement. Let,s get started:</p>
                      </div>

                      <div className="col m3">
                        <a className="detail">Settlement Details</a>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col m12">
                        <a className="waves-effect waves-light btn btn-blue save-changes">Click Here to Apply</a>
                      </div>
                    </div>
                  </div> */}
              </div>

              <div className="tutorial-btns">
                <a
                  className="waves-effect waves-light btn"
                  onClick={this.handleCloseTutorial5}
                >
                  Skip
                </a>{" "}
                {roleName === "Consumer" ? (
                  <a
                    onClick={this.openTutorialC6}
                    className="waves-effect waves-light btn"
                  >
                    Next
                  </a>
                ) : (
                  <a
                    onClick={this.openTutorialB6}
                    className="waves-effect waves-light btn"
                  >
                    Next
                  </a>
                )}
              </div>
            </DialogContent>
            <DialogActions />
          </div>
        </Dialog>

        <Dialog
          open={this.state.openTutorial8Dialog}
          onClose={this.handleCloseTutorial8}
          aria-labelledby="form-dialog-title"
          id="form-2dialog-title"
          maxWidth="md"
          className="tutorial-background-color"
          disableBackdropClick
        >
          <div id="tutorial-pop">
            <DialogContent>
              <div className="tutorial-onboard">
                <img src={tutorialBimg5} alt="tutorial-2" />

                {/* <div className="tutorial-question center-align">
                    {' '}
Please click
                    {' '}
                    <i className="material-icons hide-icon">visibility_off</i>
                    {' '}
on the hide option, if the settlement is not relevant to you.
                  </div>
                  <div className="tutorial-detail">

                    <div className="row ">
                      <div className="col m3 l2">
                        <div className="img-box"><img src={dashimg} alt="dashimg" /></div>
                        <div className="tutorial-icons">
                          <span className="hide hide-seetlementtext">Hide&nbsp;</span>
                          <i className="material-icons view-icon">visibility_off</i>
                          <div className="tutorial-arrow">
                            <i className="material-icons">arrow_backward</i>

                          </div>
                        </div>
                      </div>
                      <div className="col m6 l7">
                        <h5>
Reddylce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <p>Redylce has a class action suit against it and you could be eligible for reimbursement. Let,s get started:</p>
                      </div>

                      <div className="col m3">
                        <a className="detail">Settlement Details</a>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col m12">
                        <a className="waves-effect waves-light btn btn-blue save-changes">Click Here to Apply</a>
                      </div>
                    </div>
                  </div> */}
              </div>

              <div className="tutorial-btns">
                <a
                  className="waves-effect waves-light btn"
                  onClick={this.handleCloseTutorial5}
                >
                  Skip
                </a>{" "}
                <a
                  onClick={this.openTutorial8}
                  className="waves-effect waves-light btn"
                >
                  Next
                </a>
              </div>
            </DialogContent>
            <DialogActions />
          </div>
        </Dialog>

        <Dialog
          open={this.state.openTutorial4Dialog}
          onClose={this.handleCloseTutorial4}
          aria-labelledby="form-dialog-title"
          id="form-4dialog-title"
          className="tutorial-background-color tutorail-new-bg"
          maxWidth="md"
          disableBackdropClick
        >
          <div id="tutorial-pop">
            <DialogContent>
              <div className="tutorial-started tutorial-pop">
                <img
                  src={roleName === "Consumer" ? tutorialCimg5 : tutorialBimg6}
                  alt="tutorial-2"
                />

                {/* <h4>Let's get started</h4> */}
                <p>Ready to Start Collecting?</p>
                <button
                  className="btn waves-effect waves-light tutorial-btn"
                  name="action"
                  onClick={this.handleCloseTutorial4}
                >
                  GET STARTED
                  <i className="material-icons right">arrow_forward</i>
                </button>
              </div>
            </DialogContent>
          </div>
        </Dialog>
        <Dialog
          open={this.state.openInfoDialog}
          onClose={this.handleCloseDialogueInfo}
          aria-labelledby="form-dialog-title"
          id="form-5dialog-title"
          className="tutorial-background-color"
          maxWidth="md"
          disableBackdropClick
        >
          <div className="pop-up-eligbility">
            <DialogTitle id="form-dialog-title">
              Settlement Information
              <DialogActions className="pop-close">
                <Button onClick={this.handleCloseDialogueInfo} color="primary">
                  X
                </Button>
              </DialogActions>
            </DialogTitle>

            <DialogContent>
              <SettlementDetail />
            </DialogContent>
          </div>
          <div className="tutorial-btns">
            <a
              className="waves-effect waves-light btn"
              onClick={this.handleCloseDialogueInfo}
            >
              Skip
            </a>{" "}
            <a
              onClick={this.openTutorial2}
              className="waves-effect waves-light btn"
            >
              Next
            </a>
          </div>
        </Dialog>
        <div className="section-content dashboard">
          {console.log(
            "needAttentionPermission",
            needAttentionPermission,
            inProgressPermission,
            localStorage.getItem("userAccessObject")
          )}
          <div className="row">
            {headerText}
            {vehicleIntroText}

            <div className="dashboard-tabs">
              <div className="row ">
                <div className="dashboard-bg">
                  <div className="col s12 l4">
                    <h3>Settlements</h3>
                  </div>
                  {/** start* */}

                  <Tabs>
                    <div className="col s12 l8">
                      <TabList className="tabs">
                        <Tab className="tab col hide " />
                        <Tab
                          className={
                            promotedSettlementData.length > 0
                              ? "tab col dashboard-tabs-list"
                              : "hide"
                          }
                        >
                          <a className="settlement-heading">
                            <span>{this.state.promotedSettlementCount}</span>
                            Featured Settlements
                          </a>
                        </Tab>

                        <Tab
                          className={
                            settlementLiData.length > 0
                              ? "tab col dashboard-tabs-list"
                              : "hide"
                          }
                        >
                          {/* <div className = "hover-bg"></div> */}
                          {/* <div className="apl-btn-top arrow-tab-box"> */}
                          <div
                            className={
                              this.props.data.tutorialPopupStateAction3
                                .tutorialPopupState3 == true ||
                              (this.props.data.tutorialPopupStateAction
                                .tutorialPopupState == true &&
                                this.props.data.tutorialPopupStateAction3
                                  .tutorialPopupState3 == false)
                                ? "apl-btn-top arrow-tab-box apl-btn-up"
                                : "apl-btn-top arrow-tab-box"
                            }
                          >
                            {this.props.data.tutorialPopupStateAction3
                              .tutorialPopupState3 == true ? (
                              <div class="box-arrow arrow-right">
                                <div className="bottom-wt">
                                  <h3>New Settlements</h3>
                                  <p>
                                  Since we are constantly adding new settlements to Collectively, in the New Settlements tab, you’ll be able to keep track of the latest ones added!
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            <a className="settlement-heading">
                              <span>{this.state.settlementCount}</span>
                              New Settlements
                            </a>
                          </div>
                        </Tab>

                        {featuredSettlementPermission ? (
                          <Tab
                            className={
                              featureSettlementLiData.length > 0
                                ? "tab col dashboard-tabs-list"
                                : "hide"
                            }
                          >
                            <a className="settlement-heading">
                              <span>{featureSettlementLiData.length}</span>
                              Eligibility Matches
                            </a>
                          </Tab>
                        ) : (
                          <span />
                        )}
                        {needAttentionPermission ? (
                          <Tab
                            className={
                              getDashboardDataCount !== undefined
                                ? getDashboardDataCount.result !== undefined
                                  ? getDashboardDataCount.result
                                      .needAttentionSettlementCount > 0
                                    ? "tab col dashboard-tabs-list"
                                    : "hide"
                                  : "hide"
                                : "hide"
                            }
                          >
                            <a className="settlement-heading">
                              <span>
                                {getDashboardDataCount !== undefined
                                  ? getDashboardDataCount.result !== undefined
                                    ? getDashboardDataCount.result
                                        .needAttentionSettlementCount
                                    : 0
                                  : 0}
                              </span>
                              Needs Attention
                            </a>
                          </Tab>
                        ) : (
                          <span />
                        )}
                        {inProgressPermission ? (
                          <Tab
                            className={
                              getDashboardDataCount !== undefined
                                ? getDashboardDataCount.result !== undefined
                                  ? getDashboardDataCount.result
                                      .inProgressSettlementCount > 0
                                    ? "tab col dashboard-tabs-list"
                                    : "hide"
                                  : "hide"
                                : "hide"
                            }
                          >
                            <a className="settlement-heading">
                              <span>
                                {getDashboardDataCount !== undefined
                                  ? getDashboardDataCount.result !== undefined
                                    ? getDashboardDataCount.result
                                        .inProgressSettlementCount
                                    : 0
                                  : 0}
                              </span>
                              In-Progress Settlements
                            </a>
                          </Tab>
                        ) : (
                          <span />
                        )}
                        {completedEnrollmentPermission ? (
                       <Tab
                       className={
                         getDashboardDataCount !== undefined
                           ? getDashboardDataCount.result !== undefined
                             ? getDashboardDataCount.result
                                 .completedSettlementCount > 0
                               ? "tab col dashboard-tabs-list"
                               : "hide"
                             : "hide"
                           : "hide"
                       }
                     >
                       <a className="settlement-heading">
                         <span>
                           {getDashboardDataCount !== undefined
                             ? getDashboardDataCount.result !== undefined
                               ? getDashboardDataCount.result
                                   .completedSettlementCount
                               : 0
                             : 0}
                         </span>
                         Completed Settlements
                       </a>
                     </Tab>
                        ) : (
                          <span />
                        )}
                      </TabList>
                    </div>
                   {console.log("mixData", mixData, isLoaderData)}
                    <TabPanel className="col s12 l12 tab-data">
                      {isLoaderData === false ? (
                         mixData.length > 0 ? 
                          ( <ul>{mixData}</ul> )
                         : (
                          <ul>
                            <li>No Settlements available at the moment.</li>
                          </ul>
                          
                        )
                      ) : (
                        ""
                      )}
                      
                    </TabPanel>
                   
                    <TabPanel
                      className={
                        promotedSettlementData.length > 0
                          ? "col s12 l12 tab-data"
                          : "hide"
                      }
                    >
                      <span>
                        {promotedSettlementData.length > 0 ? (
                          <span>
                            <ul>{promotedSettlementData}</ul>
                          </span>
                        ) : (
                          <ul>
                            <li>No Featured Settlement data available.</li>
                          </ul>
                        )}
                      </span>
                    </TabPanel>
                    <TabPanel
                      className={
                        settlementLiData.length > 0
                          ? "col s12 l12 tab-data"
                          : "hide"
                      }
                    >
                      <span>
                        {settlementLiData.length > 0 ? (
                          <span>
                            <ul>{settlementLiData}</ul>
                          </span>
                        ) : (
                          <ul>
                            <li>No New Settlement data available.</li>
                          </ul>
                        )}
                      </span>
                    </TabPanel>

                    {featuredSettlementPermission ? (
                      <TabPanel
                        className={
                          featureSettlementLiData.length > 0
                            ? "col s12 l12 tab-data"
                            : "hide"
                        }
                      >
                        <span>
                          {featureSettlementLiData.length > 0 ? (
                            <span>
                              <ul>{featureSettlementLiData}</ul>
                              {/* <div className="view-all">
                                  <a onClick={this.onViewAllTrigger}>View All</a>
                                </div> */}
                            </span>
                          ) : (
                            <ul>
                              <li>No Featured data available.</li>
                            </ul>
                          )}
                        </span>
                      </TabPanel>
                    ) : null}
                    {needAttentionPermission ? (
                      <TabPanel
                        className={
                          attentionSettlementLiData.length > 0
                            ? "col s12 l12 tab-data"
                            : "hide"
                        }
                      >
                        {attentionSettlementLiData.length > 0 ? (
                          <ul>{attentionSettlementLiData}</ul>
                        ) : (
                          <ul>
                            <li>No Atention data available.</li>
                          </ul>
                        )}
                      </TabPanel>
                    ) : null}
                    {inProgressPermission ? (
                      <TabPanel
                        className={
                          enrollSettlementForUserLiData.length > 0
                            ? "col s12 l12 tab-data"
                            : "hide"
                        }
                      >
                        {enrollSettlementForUserLiData.length > 0 ? (
                          <ul>{enrollSettlementForUserLiData}</ul>
                        ) : (
                          <ul>
                            <li>No In Progress data available.</li>
                          </ul>
                        )}
                      </TabPanel>
                    ) : null}
                    {completedEnrollmentPermission ? (
                      <TabPanel
                        className={
                          completeSettlementLiData.length > 0
                            ? "col s12 l12 tab-data"
                            : "hide"
                        }
                      >
                        {completeSettlementLiData.length > 0 ? (
                          <ul>
                            {completeSettlementLiData}
                          </ul>
                        ) : (
                          <ul>
                            <li>No Completed Settlement data available.</li>
                          </ul>
                        )}
                      </TabPanel>
                    ) : null}
                  </Tabs>
                  {/** *end* */}
                </div>
              </div>
            </div>
          </div>
          {EnrichmentQuestionPermission ? <span> {question} </span> : <div />}
        </div>
      </span>
    );
  }
}

Dashboard.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  data: state.data,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllVehicleYear,
      getTotalFundSettlement,
      getAllVehicleMake,
      getAllVehicleModel,
      getAllVehicleTrim,
      addVehicleData,
      getAllVehicleDataByUserId,
      deleteVehicleRecordsData,
      viewVehicleEditRecord,
      updateAutoSettlementFlag,
      getConsumerUser,
      tutorialPopupStateAction3,
      tutorialPopupStateAction4,
    },
    dispatch
  );

export default withAlert(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
